import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');

  const switchLanguage = (lang) => {
    if (lang === 'en' && !isEnglish) {
      // Switch to English
      const newPath = '/en' + location.pathname;
      navigate(newPath);
    } else if (lang === 'de' && isEnglish) {
      // Switch to German
      const newPath = location.pathname.replace('/en', '');
      navigate(newPath || '/');
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-5 h-5 text-charcoal/60" />
      <button
        onClick={() => switchLanguage('de')}
        className={`px-3 py-1 rounded-lg transition-colors ${
          !isEnglish 
            ? 'bg-olive-green text-white font-semibold' 
            : 'text-charcoal/60 hover:text-charcoal hover:bg-gray-100'
        }`}
      >
        DE
      </button>
      <span className="text-charcoal/40">|</span>
      <button
        onClick={() => switchLanguage('en')}
        className={`px-3 py-1 rounded-lg transition-colors ${
          isEnglish 
            ? 'bg-olive-green text-white font-semibold' 
            : 'text-charcoal/60 hover:text-charcoal hover:bg-gray-100'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
